// Assuming `useRootStore` is imported correctly from your store setup
import React from "react";

import { Notifications } from "./components/Notifications";

export const BpMobileNotifications: React.FC = () => {
  return <Notifications />;
};
